import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Long: number;
};

export type AgeGroupGeneric = {
  __typename?: 'AgeGroupGeneric';
  from: Scalars['Int'];
  to?: Maybe<Scalars['Int']>;
};

export type ByAgeGenderAndContinentLineW = {
  __typename?: 'ByAgeGenderAndContinentLineW';
  ageValues: Array<ByAgeGenderLineW>;
  continent: ContinentW;
  countryValues: Array<ByAgeGenderAndCountryLineW>;
  value: ByGenderLineW;
};


export type ByAgeGenderAndContinentLineWAgeValuesArgs = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type ByAgeGenderAndCountryLineW = {
  __typename?: 'ByAgeGenderAndCountryLineW';
  ageValues: Array<ByAgeGenderLineW>;
  country: CountryW;
  value: ByGenderLineW;
};


export type ByAgeGenderAndCountryLineWAgeValuesArgs = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type ByAgeGenderLineW = {
  __typename?: 'ByAgeGenderLineW';
  ageGroup: AgeGroupGeneric;
  value: ByGenderLineW;
};

export type ByCountyCountryLineW = {
  __typename?: 'ByCountyCountryLineW';
  country: CountryW;
  values: Array<ByCountyLineW>;
};

export type ByCountyLineW = {
  __typename?: 'ByCountyLineW';
  county: CountyW;
  value: PopulationAndHeadcountW;
};

export type ByGenderLineW = {
  __typename?: 'ByGenderLineW';
  females: PopulationAndHeadcountW;
  males: PopulationAndHeadcountW;
  overall: PopulationAndHeadcountW;
};

export type ByRegionContinentLineW = {
  __typename?: 'ByRegionContinentLineW';
  continent: ContinentW;
  countryValues: Array<ByRegionCountryLineW>;
  value: ByRegionLineW;
};

export type ByRegionCountryLineW = {
  __typename?: 'ByRegionCountryLineW';
  country: CountryW;
  value: ByRegionLineW;
};

export type ByRegionLineW = {
  __typename?: 'ByRegionLineW';
  overall: PopulationAndHeadcountW;
  ruralValue: PopulationAndHeadcountW;
  urbanValue: PopulationAndHeadcountW;
};

export type ContinentW = {
  __typename?: 'ContinentW';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CountryW = {
  __typename?: 'CountryW';
  id: Scalars['String'];
  name: Scalars['String'];
  parentRegionId: ContinentW;
};

export type CountyW = {
  __typename?: 'CountyW';
  countryId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type PopulationAndHeadcountW = {
  __typename?: 'PopulationAndHeadcountW';
  currEscapeRate: Scalars['Float'];
  escapeFromPovertyRate: Scalars['Float'];
  fellIntoPovertyRate: Scalars['Float'];
  headcount: Scalars['Long'];
  sdgHeadcount: Scalars['Long'];
  stableTrack: Scalars['Int'];
  targetEscapeRate: Scalars['Float'];
  totalPopulation: Scalars['Long'];
};

export type Query = {
  __typename?: 'Query';
  worldPovertyAgeGender?: Maybe<WorldPovertyAgeGender>;
  worldPovertyCounty?: Maybe<WorldPovertyCounty>;
  worldPovertyRegion?: Maybe<WorldPovertyRegion>;
};


export type QueryWorldPovertyAgeGenderArgs = {
  countryIds: Array<Scalars['String']>;
  dailySpending: Scalars['Float'];
  year: Scalars['Int'];
};


export type QueryWorldPovertyCountyArgs = {
  countryIds: Array<Scalars['String']>;
  dailySpending: Scalars['Float'];
  year: Scalars['Int'];
};


export type QueryWorldPovertyRegionArgs = {
  countryIds: Array<Scalars['String']>;
  dailySpending: Scalars['Float'];
  year: Scalars['Int'];
};

export type WorldPovertyAgeGender = {
  __typename?: 'WorldPovertyAgeGender';
  ageValues: Array<ByAgeGenderLineW>;
  continentValues: Array<ByAgeGenderAndContinentLineW>;
  countryValues: Array<ByAgeGenderAndCountryLineW>;
  value: ByGenderLineW;
};


export type WorldPovertyAgeGenderAgeValuesArgs = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type WorldPovertyCounty = {
  __typename?: 'WorldPovertyCounty';
  countyValues?: Maybe<Array<ByCountyCountryLineW>>;
};

export type WorldPovertyRegion = {
  __typename?: 'WorldPovertyRegion';
  continentValues: Array<ByRegionContinentLineW>;
  countryValues: Array<ByRegionCountryLineW>;
  value: ByRegionLineW;
};

export type MainQueryVariables = Exact<{
  year?: Scalars['Int'];
  dailySpending?: Scalars['Float'];
  regionDailySpending?: Scalars['Float'];
  from?: Scalars['Int'];
  to?: InputMaybe<Scalars['Int']>;
}>;


export type MainQuery = { __typename?: 'Query', mainQueryAgeGender?: { __typename?: 'WorldPovertyAgeGender', ageValues: Array<{ __typename?: 'ByAgeGenderLineW', ageGroup: { __typename?: 'AgeGroupGeneric', from: number, to?: number | null }, value: { __typename?: 'ByGenderLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, males: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, females: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } } }>, value: { __typename?: 'ByGenderLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, males: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, females: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } }, continentValues: Array<{ __typename?: 'ByAgeGenderAndContinentLineW', continent: { __typename?: 'ContinentW', name: string, id: number }, ageValues: Array<{ __typename?: 'ByAgeGenderLineW', ageGroup: { __typename?: 'AgeGroupGeneric', from: number, to?: number | null }, value: { __typename?: 'ByGenderLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, males: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, females: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } } }>, value: { __typename?: 'ByGenderLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, males: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, females: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } } }>, countryValues: Array<{ __typename?: 'ByAgeGenderAndCountryLineW', country: { __typename?: 'CountryW', name: string, id: string }, value: { __typename?: 'ByGenderLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, males: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, females: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } }, ageValues: Array<{ __typename?: 'ByAgeGenderLineW', ageGroup: { __typename?: 'AgeGroupGeneric', from: number, to?: number | null }, value: { __typename?: 'ByGenderLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, males: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, females: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } } }> }> } | null, mainQueryRegion?: { __typename?: 'WorldPovertyRegion', value: { __typename?: 'ByRegionLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, rural: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, urban: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } }, continentValues: Array<{ __typename?: 'ByRegionContinentLineW', continent: { __typename?: 'ContinentW', name: string, id: number }, value: { __typename?: 'ByRegionLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, rural: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, urban: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } } }>, countryValues: Array<{ __typename?: 'ByRegionCountryLineW', country: { __typename?: 'CountryW', name: string, id: string }, value: { __typename?: 'ByRegionLineW', overall: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, rural: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number }, urban: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } } }> } | null, mainQueryCounty?: { __typename?: 'WorldPovertyCounty', countyValues?: Array<{ __typename?: 'ByCountyCountryLineW', country: { __typename?: 'CountryW', name: string, id: string }, values: Array<{ __typename?: 'ByCountyLineW', county: { __typename?: 'CountyW', name: string, id: number }, value: { __typename?: 'PopulationAndHeadcountW', totalPopulation: number, headcount: number, sdgHeadcount: number, stableTrack: number, targetEscapeRate: number, currEscapeRate: number, fellIntoPovertyRate: number, escapeFromPovertyRate: number } }> }> | null } | null };


export const MainDocument = gql`
    query main($year: Int! = 2023, $dailySpending: Float! = 2.15, $regionDailySpending: Float! = 2.15, $from: Int! = 0, $to: Int = null) {
  mainQueryAgeGender: worldPovertyAgeGender(
    year: $year
    dailySpending: $dailySpending
    countryIds: []
  ) {
    ageValues(from: $from, to: $to) {
      ageGroup {
        from
        to
      }
      value {
        overall {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        males {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        females {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
      }
    }
    value {
      overall {
        totalPopulation
        headcount
        sdgHeadcount
        stableTrack
        targetEscapeRate
        currEscapeRate
        fellIntoPovertyRate
        escapeFromPovertyRate
      }
      males {
        totalPopulation
        headcount
        sdgHeadcount
        stableTrack
        targetEscapeRate
        currEscapeRate
        fellIntoPovertyRate
        escapeFromPovertyRate
      }
      females {
        totalPopulation
        headcount
        sdgHeadcount
        stableTrack
        targetEscapeRate
        currEscapeRate
        fellIntoPovertyRate
        escapeFromPovertyRate
      }
    }
    continentValues {
      continent {
        name
        id
      }
      ageValues(from: $from, to: $to) {
        ageGroup {
          from
          to
        }
        value {
          overall {
            totalPopulation
            headcount
            sdgHeadcount
            stableTrack
            targetEscapeRate
            currEscapeRate
            fellIntoPovertyRate
            escapeFromPovertyRate
          }
          males {
            totalPopulation
            headcount
            sdgHeadcount
            stableTrack
            targetEscapeRate
            currEscapeRate
            fellIntoPovertyRate
            escapeFromPovertyRate
          }
          females {
            totalPopulation
            headcount
            sdgHeadcount
            stableTrack
            targetEscapeRate
            currEscapeRate
            fellIntoPovertyRate
            escapeFromPovertyRate
          }
        }
      }
      value {
        overall {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        males {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        females {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
      }
    }
    countryValues {
      country {
        name
        id
      }
      value {
        overall {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        males {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        females {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
      }
      ageValues(from: $from, to: $to) {
        ageGroup {
          from
          to
        }
        value {
          overall {
            totalPopulation
            headcount
            sdgHeadcount
            stableTrack
            targetEscapeRate
            currEscapeRate
            fellIntoPovertyRate
            escapeFromPovertyRate
          }
          males {
            totalPopulation
            headcount
            sdgHeadcount
            stableTrack
            targetEscapeRate
            currEscapeRate
            fellIntoPovertyRate
            escapeFromPovertyRate
          }
          females {
            totalPopulation
            headcount
            sdgHeadcount
            stableTrack
            targetEscapeRate
            currEscapeRate
            fellIntoPovertyRate
            escapeFromPovertyRate
          }
        }
      }
    }
  }
  mainQueryRegion: worldPovertyRegion(
    year: $year
    dailySpending: $regionDailySpending
    countryIds: []
  ) {
    value {
      overall {
        totalPopulation
        headcount
        sdgHeadcount
        stableTrack
        targetEscapeRate
        currEscapeRate
        fellIntoPovertyRate
        escapeFromPovertyRate
      }
      rural: ruralValue {
        totalPopulation
        headcount
        sdgHeadcount
        stableTrack
        targetEscapeRate
        currEscapeRate
        fellIntoPovertyRate
        escapeFromPovertyRate
      }
      urban: urbanValue {
        totalPopulation
        headcount
        sdgHeadcount
        stableTrack
        targetEscapeRate
        currEscapeRate
        fellIntoPovertyRate
        escapeFromPovertyRate
      }
    }
    continentValues {
      continent {
        name
        id
      }
      value {
        overall {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        rural: ruralValue {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        urban: urbanValue {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
      }
    }
    countryValues {
      country {
        name
        id
      }
      value {
        overall {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        rural: ruralValue {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
        urban: urbanValue {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
      }
    }
  }
  mainQueryCounty: worldPovertyCounty(
    year: $year
    dailySpending: $dailySpending
    countryIds: []
  ) {
    countyValues {
      country {
        name
        id
      }
      values {
        county {
          name
          id
        }
        value {
          totalPopulation
          headcount
          sdgHeadcount
          stableTrack
          targetEscapeRate
          currEscapeRate
          fellIntoPovertyRate
          escapeFromPovertyRate
        }
      }
    }
  }
}
    `;

/**
 * __useMainQuery__
 *
 * To run a query within a React component, call `useMainQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainQuery({
 *   variables: {
 *      year: // value for 'year'
 *      dailySpending: // value for 'dailySpending'
 *      regionDailySpending: // value for 'regionDailySpending'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMainQuery(baseOptions?: Apollo.QueryHookOptions<MainQuery, MainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainQuery, MainQueryVariables>(MainDocument, options);
      }
export function useMainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainQuery, MainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainQuery, MainQueryVariables>(MainDocument, options);
        }
export type MainQueryHookResult = ReturnType<typeof useMainQuery>;
export type MainLazyQueryHookResult = ReturnType<typeof useMainLazyQuery>;
export type MainQueryResult = Apollo.QueryResult<MainQuery, MainQueryVariables>;
export function refetchMainQuery(variables?: MainQueryVariables) {
      return { query: MainDocument, variables: variables }
    }